import { createAction } from '@reduxjs/toolkit';

export interface OrgMembersState {
    OrgMembers: any[];
}

export const initialState: OrgMembersState = {
    OrgMembers: [],
}

export const setOrgMembers = createAction<any[]>('orgMembers/setOrgMembers');